module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__customer-groups"
    }
  }, [_c('md-content', {
    attrs: {
      "md-theme": "white",
      "loading": _vm.progress
    }
  }, [_c('user-menu'), _vm._v(" "), _c('sort-table', {
    ref: "table",
    attrs: {
      "columns": _vm.tableColumns,
      "link": "",
      "per-page": _vm.perPage,
      "total": _vm.groupsAmount,
      "table-id": "customer-groups",
      "tableHeight": "calc(100% - 48px)"
    },
    on: {
      "refresh": _vm.getCustomerGroups,
      "create": _vm.addGroup
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "danger-light": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }]),
    model: {
      value: (_vm.groups),
      callback: function($$v) {
        _vm.groups = $$v
      },
      expression: "groups"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01e9aafe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/customers/views/Groups.vue
// module id = 1022
// module chunks = 0